<template>
  <vue-element-loading :active="status" :delay="0" :is-full-screen="fullPage" color="#4299E1" spinner="bar-fade-scale"></vue-element-loading>
</template>
<script>
export default {
  name: 'loading',
  props: {
    status: {
      type: Boolean,
      required: true,
      default: true,
    },
    fullPage: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    status(value) {
      value ? this.$nprogress.start() : this.$nprogress.done();
    },
  },
};
</script>
